import React, { useState } from 'react';
import Chart from './Chart';
import ProductChart from './ProductChart';

function Piechart({ categoryChartData, productCountByCategory }) {

  return (
    <div className="reportmap reportmapanalysy">
      <div className="reportmap_1">
        {categoryChartData?.length > 0 && (
          <Chart categoryChartData={categoryChartData} />
        )}

        {productCountByCategory?.length > 0 && (
          <ProductChart productCountByCategory={productCountByCategory} />
        )}
      </div>
    </div>
  );
}

export default Piechart;
